module.exports = __webpack_public_path__ + "img/10.dc0badf2.png";